import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AutoTextarea } from "@/components/AutoTextarea";
import { VoiceButton, appendText } from "@/components/VoiceButton";
import { api, errMsg } from "@/lib/api";
import { useInvalidate } from "@/lib/queries";
import { allCategories, catLabel } from "@/lib/lore";

export const QuickNoteForm = ({ uid, onClose, onCreated }) => {
  const invalidate = useInvalidate();
  const [name, setName] = useState("");
  const [category, setCategory] = useState("Lore");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/universes/${uid}/entities`, { name: name.trim(), category, content: text.trim(), summary: "", attributes: {} });
      invalidate(["entities", uid]);
      toast.success(`Saved “${data.name}” to the Lore Bible`);
      onCreated(data);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-2 rounded-md border border-[#D97706]/40 bg-[#13171F] p-3" data-testid="widget-quick-note">
      <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Note title" maxLength={120} autoFocus className="h-8 text-sm" data-testid="widget-quick-note-name" />
      <Select value={category} onValueChange={setCategory}>
        <SelectTrigger className="h-8 text-xs" data-testid="widget-quick-note-category"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-72">{allCategories().filter((c) => c !== "Relationship").map((c) => <SelectItem key={c} value={c}>{catLabel(c)}</SelectItem>)}</SelectContent>
      </Select>
      <AutoTextarea value={text} onChange={(e) => setText(e.target.value)} maxVh={30} placeholder="What do you need to remember?" className="min-h-[90px] text-sm" data-testid="widget-quick-note-text" />
      <div className="flex items-center justify-between gap-2">
        <VoiceButton uid={uid} onText={(t) => setText((p) => appendText(p, t))} testid="widget-quick-note-voice" />
        <div className="flex gap-1.5">
          <Button size="sm" variant="ghost" onClick={onClose} data-testid="widget-quick-note-cancel">Cancel</Button>
          <Button size="sm" onClick={save} disabled={busy || !name.trim()} data-testid="widget-quick-note-save">{busy ? "Saving…" : "Save note"}</Button>
        </div>
      </div>
    </div>
  );
};
